import { CHART_TOKENS } from "./theme";

// Floating tooltip that sits over the chart container. We used to measure
// the tooltip with useLayoutEffect to flip it leftward near the right edge,
// but mounting/unmounting that ref during rapid hover churn raced with
// React 18's reconciliation and produced spurious ``removeChild`` errors
// on unmount. The pointer-events: none + translate approach keeps the
// tooltip inside the container without any measurement.
export const ChartTooltip = ({ x, y, children, visible }) => {
  if (!visible) return null;
  return (
    <div
      style={{
        position: "absolute",
        left: 0,
        top: 0,
        transform: `translate(${x + 12}px, ${Math.max(0, y - 14)}px)`,
        maxWidth: "calc(100% - 16px)",
        padding: "6px 10px",
        borderRadius: 6,
        background: CHART_TOKENS.tooltipBg,
        color: CHART_TOKENS.tooltipFg,
        fontSize: "var(--font-size-caption)",
        lineHeight: 1.4,
        pointerEvents: "none",
        whiteSpace: "nowrap",
        boxShadow: "0 4px 12px rgba(0,0,0,0.18)",
        zIndex: 5,
      }}
    >
      {children}
    </div>
  );
};
